import React, { Fragment } from "react";
import Bg from "../Bg";
import styled, { css, ThemeProvider } from "styled-components";
import { themes } from "../../defaults";
import Colorer from "color";
import { CSSpsFormGroup, Button, ContentBlock, CssPaper, Paper } from '../uikit-b2c/uikit-b2c';
import { Svg } from "../uikit-b2c/Svg";
import { InputM } from '../uikit-b2c/InputM';
import { CSSoneMethod, CSSsvgMethod, PSmethods } from './PSmethods';
import { methods } from '../uikit-b2c/methods';
import { getIcon } from '../uikit-b2c/cardIcons';

export function MethodPP({ theme = themes[0] }) {
  return (
    <ThemeProvider theme={theme}>
      <ContentBlock
        appearance="secondary"
        indentation={2}
        paddings={"sm"}
      >


        <CSSpsFormGroup>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gridColumnGap: 8,
        }}>
          <InputM
            autofocus
            value=''
            size='md'
            handle={()=>void(0)}
            label="Paypal email"
          />
          <Button blocked={true}>

            <div style={{
              margin: '-8px 0 -8px 0',
            }}>

            <PSmethods
                flatten
                compact
                height={16}
                methods={[methods['method_pp']]}
                forceHeight={8}
              />

                </div>

          </Button>
        </div>
        </CSSpsFormGroup>


      </ContentBlock>
    </ThemeProvider>
  );
}


export function MethodCVS({ saved, theme = themes[0] }) {
  return (
    <ThemeProvider theme={theme}>

<Fragment>

      {saved && (
          <ContentBlock indentation={0} paddings={"sm"}>
            {/* <CssCardBody
              style={{
                // backgroundColor: Colorer(theme['colorBg']).lighten(0.2).string()
              }}
            > */}


              <Paper>

                <div className="">
                  <InputM
                    type="cardNumber"
                    style={{ width: "100%" }}
                    disabled={true}
                    size='md'
                    // autofocus={true}
                    // placeholder="0000 0000 0000 0000"
                    value='mi***@gm***.com'
                    // handle={() => void 0}
                    label="Saved CSV account"
                    extra={<Svg>{methods['method_cvs']["icon"]}</Svg>}
                    // monospace
                  />
                </div>

              </Paper>



          </ContentBlock>
      )}

      {!saved && <ContentBlock
        appearance="secondary"
        indentation={2}
        paddings={"sm"}
      >



        <CSSpsFormGroup>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gridColumnGap: 8,
        }}>
          <InputM
            autofocus
            value=''
            size='md'
            handle={()=>void(0)}
            label="CVS Gift-card 16 digit number"
          />
          <Button blocked={true}>
          <div style={{
              margin: '-8px 0 -8px 0',
            }}>

              <PSmethods
                compact
                methods={[methods['method_cvs']]}
                forceHeight={8}
              />
                </div>

          </Button>
        </div>
        </CSSpsFormGroup>

      </ContentBlock>}
      </Fragment>
    </ThemeProvider>
  );
}


